import { useCallback, useEffect, useState } from "react"

import { Box, FormControl, FormControlLabel, Grid, RadioGroup, Typography } from '@mui/material'
import AdvanceApi, { AdvanceListInterface } from "api/finances/advance.api"
import { resetModal } from "app/slice/modal.slice"
import { setBankCredit, setBankDebit, setBankTransfer, valBankCredit, valBankDebit, valBankTransfer } from "app/slice/payment.slice"
import ButtonCustom from "component/Button/ButtonCustom"
import InputRadio from "component/Input/InputRadio"
import InputTextarea from "component/Input/InputTextarea"
import InputTextField from "component/Input/InputTextField"
import Loading from "component/Loading"
import ModalCustom from "component/ModalCustom/ModalCustom"
import { notiError, notiSuccess } from "component/notifications/notifications"
import SearchPatients from "component/SearchPatients"
import TableCustom from "component/Table/TableCustom"
import TableRowCommon from "component/Table/TableRowCommon"
import { colors } from "constants/theme"
import * as UseStyled from 'features/finance/payment/component/popupPayment/UseStyledFormPayment'
import _ from "lodash"
import MainButton from "new-components/buttons/main-button"
import { Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { getBranch, numberFormat, numberToCurrencyFormat } from "utils/app.utils"
import { dateToView } from "utils/date.utils"
import Info from "./Info"
import PaymentChannels from "./PaymentChannels"

export interface IFormAdvanceProps {
  isShow: boolean
  advanceHistory: { history: AdvanceListInterface[], rowCount: number }
  patient: any
  banks: any
  loadHistory: (filter: any) => void
  setIsShow: (isShow: boolean) => void
  handleSuccess?: () => void
}

export function ManageAdvance(props: IFormAdvanceProps) {
  const { t } = useTranslation()
  const branchId = getBranch()
  const dispatch = useDispatch()
  const bankCredit = useSelector(valBankCredit)
  const bankDebit = useSelector(valBankDebit)
  const bankTransfer = useSelector(valBankTransfer)


  const [fillter, setFillter] = useState({ patientId: 0, page: 1, pageLimit: 10, sortBy: 'createdAt', sortType: "DESC" })
  const [dataEdit, setDataEdit] = useState<{ data?: AdvanceListInterface, action: "TRANSFER" | "ADJUST", newPatientId: number | 0, amount: 0, newPatient?: any } | any>({})
  const [dataChange, setDataChange] = useState<any>({})
  const [disabledNext, setDisabledNext] = useState<boolean>(false)
  const [transferAmount, setTransferAmount] = useState<number>(0)
  const [adjustTargetBalance, setAdjustTargetBalance] = useState<number>(0)
  const [adjustRemark, setAdjustRemark] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [transferOption, setTransferOption] = useState<'TO_PATIENT' | 'CUT_OUT'>('TO_PATIENT')

  const [activePage, setActivePage] = useState(0)


  const paymentChannels = [
    { key: 'TREATMENTRIGHT', paymentChanel: 5, isActive: false },
    { key: 'ADVANCE', paymentChanel: 6, isActive: false },
    { key: 'CASH', paymentChanel: 1, isActive: false },
    { key: 'TRANSFER', paymentChanel: 2, isActive: false },
    { key: 'CREDIT', paymentChanel: 3, isActive: false },
    { key: 'DEBIT', paymentChanel: 4, isActive: false },
    { key: 'VOUCHER', paymentChanel: 7, isActive: false },
    { key: 'PROMOTION', paymentChanel: 8, isActive: false },
    { key: 'WALLET', paymentChanel: 10, isActive: false }

  ]
  useEffect(() => {
    props.loadHistory(fillter)
  }, [fillter]);

  useEffect(() => {
    setDataEdit({ data: null, action: "TRANSFER", newPatientId: 0, amount: 0, newPatient: null })
    setFillter({ patientId: 0, page: 1, pageLimit: 10, sortBy: 'createdAt', sortType: "DESC" })
    setTransferAmount(0)
    setAdjustTargetBalance(0)
    setAdjustRemark('')
    setTransferOption('TO_PATIENT')
  }, [props.isShow]);



  const loadAdvance = useCallback(async ({ data, action }) => {
    dispatch(setBankTransfer({}))
    dispatch(setBankCredit({}))
    dispatch(setBankDebit({}))

    // For ADJUST action, set initial values and return early
    if (action === "ADJUST") {
      // Set target balance to current advance balance as default
      setAdjustTargetBalance(data.advanceBalance || 0)
      setAdjustRemark('')
      setDataEdit({ data, action, newPatientId: 0, amount: 0, newPatient: null })
      return
    }

    const respAdvances = await AdvanceApi.findById(data.transectionAdvanceId)
    if (respAdvances.status === 200) {
      const paidAdvance = respAdvances.data
      const transectionAdvanceItems = paidAdvance.transectionAdvanceItems
      if (transectionAdvanceItems.length) {
        const selectChannels = []
        let amountCash = 0, amountTransfer = 0, amountCredit = 0, amountDebit = 0, amountVoucher = 0, amountWallet = 0
        let usedCash = 0, usedTransfer = 0, usedCredit = 0, usedDebit = 0, usedVoucher = 0, usedWallet = 0

        const paid: any = {}
        for (let index = 0; index < transectionAdvanceItems.length; index++) {
          const item = transectionAdvanceItems[index];
          const channel = _.find(paymentChannels, { paymentChanel: item.paymentChannelId })
          selectChannels.push(channel)


          const bank = _.find(props.banks, { bankId: item.bankId })
          console.log({ ...bank, cardTypeId: item.cardTypeId });

          if (item.paymentChannelId === 1) {
            amountCash = amountCash + (item.amount - item.used)
            usedCash = usedCash + item.used
            paid.amountCash = amountCash
            paid.usedCash = usedCash
          }
          else if (item.paymentChannelId === 10) {
            amountWallet = amountWallet + (item.amount - item.used)
            usedWallet = usedWallet + item.used
            paid.amountWallet = amountWallet
            paid.usedWallet = usedWallet
          }
          else if (item.paymentChannelId === 2) {
            amountTransfer = amountTransfer + (item.amount - item.used)
            usedTransfer = usedTransfer + item.used

            paid.amountTransfer = amountTransfer
            paid.usedTransfer = usedTransfer
            dispatch(setBankTransfer(bank))
          }
          else if (item.paymentChannelId === 3) {
            amountCredit = amountCredit + (item.amount - item.used)
            usedCredit = usedCredit + item.used

            paid.amountCredit = amountCredit
            paid.usedCredit = usedCredit


            dispatch(setBankCredit({ ...bank, cardTypeId: item.cardTypeId }))

          }
          else if (item.paymentChannelId === 4) {
            amountDebit = amountDebit + (item.amount - item.used)
            usedDebit = usedDebit + item.used
            paid.amountDebit = amountDebit
            paid.usedDebit = usedDebit
            dispatch(setBankDebit({ ...bank, cardTypeId: item.cardTypeId }))

          }
          else if (item.paymentChannelId === 7) {
            amountVoucher = amountVoucher + (item.amount - item.used)
            usedVoucher = usedVoucher + item.used
            paid.amountVoucher = amountVoucher
            paid.usedVoucher = usedVoucher
          }
        }
        data.transectionAdvanceItems = transectionAdvanceItems

        console.log('selectChannels', selectChannels);

        setDataEdit({ data, action, selectChannels, newPatientId: 0, newPatient: null })
        setDataChange({ ...data, ...paid, })
        if (action === "TRANSFER") {
          setTransferAmount(0)
        }
      }
    }
  }, [])

  const handleChange = (value: any) => {
    const sumPaid = (value.amountCash || 0) + (value.amountTransfer || 0) + (value.amountCredit || 0) + (value.amountDebit || 0) + (value.amountWallet || 0)
    setDataChange((old: any) => ({ ...old, ...value }))
  }

  const headCells = [
    { id: 'no', disablePadding: false, label: t('#'), class: 'text-nowrap' },
    { id: 'dateAt', disablePadding: false, label: t('ADVANCE.TABLE.DATE'), class: 'text-nowrap' },
    { id: 'paymentNumber', disablePadding: false, label: t('ADVANCE.TABLE.BILL_NO'), class: 'text-nowrap' },
    { id: 'patientFullName', disablePadding: false, label: t('ADVANCE.TABLE.PATIENT_FULL_NAME'), class: 'text-nowrap' },
    // { id: 'orderPaymentChannel', disablePadding: false, label: t('ADVANCE.TABLE.PAYMENT_CHANNELS'), class: 'text-nowrap' },
    { id: 'total', disablePadding: false, label: t('ADVANCE.TABLE.TOTAL'), class: 'text-nowrap' },
    { id: 'remaining', disablePadding: false, label: t('ADVANCE.TABLE.REMAINING'), class: 'text-nowrap' },
    { id: 'statusOrder', disablePadding: false, label: t('ADVANCE.TABLE.STATUS'), class: 'text-nowrap' },
    { id: 'createdBy', disablePadding: false, label: t('ADVANCE.TABLE.STAFF'), class: 'text-nowrap' },
    { id: 'action', disablePadding: false, label: t('ADVANCE.TABLE.ACTION'), class: 'text-nowrap head-action' }
  ]

  const renderData = (objData: AdvanceListInterface, no: number) => {
    no = fillter.page * fillter.pageLimit - fillter.pageLimit + no + 1
    const { transectionAdvanceId: id, date, prefix, cnNumber, branchCnNumber, patientFullName, advanceNumber: advanceNum, paymentChannelText, amountTotal, createdBy: staffBy, statusOrder, advanceBalance } = objData

    const billNo = `${prefix}-${advanceNum}`
    const amount = numberToCurrencyFormat(amountTotal)
    const balance = numberToCurrencyFormat(advanceBalance)
    const objRenderData = {
      key: String(no),
      id: String(id),
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'center', label: dateToView(date) || '-', class: 'text-nowrap-ellipsis' },
        { option: 'TEXT', align: 'left', label: billNo || '-', class: 'text-nowrap-ellipsis' },
        { option: 'TEXT', align: 'left', label: patientFullName || '-', class: 'text-nowrap-ellipsis' },
        // { option: 'TEXT', align: 'left', label: paymentChannelText || '-', class: 'text-nowrap-ellipsis' },
        { option: 'TEXT', align: 'right', label: amount || '-', class: 'text-nowrap-ellipsis' },
        { option: 'TEXT', align: 'right', label: balance || '-', class: 'text-nowrap-ellipsis' },
        { option: 'TEXT', align: 'center', label: t(`ADVANCE.STATUS.${statusOrder}`) || '-', class: 'text-nowrap-ellipsis' },
        { option: 'TEXT', align: 'left', label: staffBy || '-', class: 'text-nowrap-ellipsis' },
        {
          option: 'COMPONENT',
          align: 'center',
          component: (
            <div className="text-nowrap d-flex ">
              {/* <ButtonCustom mode="default" className={'ml-2'} type={'button'} disabled={statusOrder === 'CANCEL'} variant={'contained'} textButton={t('ปรับเปลี่ยนยอด')} onClick={() => loadAdvance({ data: objData, action: "ADJUST" })} /> */}
              <ButtonCustom mode="default" className={'ml-2'} type={'button'} disabled={statusOrder === 'CANCEL' || advanceBalance <= 0} variant={'contained'} textButton={t('โอนเงินล่วงหน้า')} onClick={() => loadAdvance({ data: objData, action: "TRANSFER" })} />
            </div>
          ),
          class: 'text-nowrap-ellipsis'
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onClick={(e, val) => {
          return
        }}
      />
    )
  }


  const submit = () => {
    if (loading) return
    // Handle TRANSFER action separately
    if (dataEdit.action === "TRANSFER") {
      // Validation for TRANSFER action
      if (transferOption === 'TO_PATIENT' && (!dataEdit.newPatientId || dataEdit.newPatientId === 0)) {
        return notiError(t('ADVANCE.MESSAGE.ERROR.PATIENT_REQUIRED'))
      }

      // Check if transferring to the same patient (only when transferring to another patient)
      if (dataEdit.data.patientId === dataEdit.newPatientId) {
        return notiError(t('ADVANCE.MESSAGE.ERROR.CANNOT_TRANSFER_ADVANCE_TO_THE_SAME_PATIENT'))
      }

      if (!transferAmount || transferAmount <= 0) {
        return notiError(t('ADVANCE.MESSAGE.ERROR.AMOUNT_REQUIRED'))
      }

      if (transferAmount > dataEdit.data.advanceBalance) {
        return notiError(t('ADVANCE.MESSAGE.ERROR.AMOUNT_EXCEED_BALANCE'))
      }

      const transferPayload = {
        transectionAdvanceId: dataChange.transectionAdvanceId,
        fromPatientId: dataEdit.data.patientId,
        toPatientId: dataEdit?.newPatientId || 0,
        shouldTransferToPatient: transferOption === 'TO_PATIENT',
        amount: transferAmount,
        remark: dataEdit.data.remark || ''
      }

      setLoading(true)
      AdvanceApi.transfer(transferPayload)
        .then((res: any) => {
          if (res.status !== undefined && res.status === 201) {
            if (props?.handleSuccess) props?.handleSuccess()
            dispatch(resetModal())
            setDataEdit({ data: null, action: "TRANSFER", newPatientId: 0, amount: 0, newPatient: null })
            setFillter({ patientId: 0, page: 1, pageLimit: 10, sortBy: 'createdAt', sortType: "DESC" })
            setDataChange(null)
            setTransferAmount(0)
            setTransferOption('TO_PATIENT')
            const translatedMessage = t('ADVANCE.MESSAGE.SUCCESS.TRANSFER')
            notiSuccess(translatedMessage === 'ADVANCE.MESSAGE.SUCCESS.TRANSFER' ? 'โอนเงินล่วงหน้าสำเร็จ' : translatedMessage)
            props?.setIsShow(false)
          } else {
            const err = res.response?.data
            notiError(t(`ADVANCE.MESSAGE.ERROR.${err?.message}`))
          }
        })
        .catch((e) => {
          const err = e.response?.data
          notiError(t(`ADVANCE.MESSAGE.ERROR.${err?.message}`))
        })
        .finally(() => {
          setLoading(false)
        })

      return
    }

    // Handle ADJUST action - use adjustBalance API
    if (dataEdit.action === "ADJUST") {
      // Validate target balance
      if (adjustTargetBalance < 0) {
        return notiError(t('ยอดคงเหลือที่ต้องการต้องไม่น้อยกว่า 0'))
      }

      const adjustPayload = {
        transectionAdvanceId: dataEdit.data.transectionAdvanceId,
        amount: adjustTargetBalance, // Target balance (ยอดคงเหลือที่ต้องการ)
        remark: adjustRemark || ''
      }

      setLoading(true)
      AdvanceApi.adjustBalance(adjustPayload)
        .then((res: any) => {
          if (res.status !== undefined && res.status === 201) {
            if (props?.handleSuccess) props?.handleSuccess()
            dispatch(resetModal())
            setDataEdit({ data: null, action: "TRANSFER", newPatientId: 0, amount: 0, newPatient: null })
            setFillter({ patientId: 0, page: 1, pageLimit: 10, sortBy: 'createdAt', sortType: "DESC" })
            setDataChange(null)
            const translatedMessage = t('ADVANCE.MESSAGE.SUCCESS.ADJUST_BALANCE')
            notiSuccess(translatedMessage === 'ADVANCE.MESSAGE.SUCCESS.ADJUST_BALANCE' ? 'ปรับเปลี่ยนยอดคงเหลือสำเร็จ' : translatedMessage)
            props?.setIsShow(false)
          } else {
            const err = res.response?.data
            notiError(t(`ADVANCE.MESSAGE.ERROR.${err?.message}`) || err?.message || 'เกิดข้อผิดพลาด')
          }
        })
        .catch((e) => {
          const err = e.response?.data
          notiError(t(`ADVANCE.MESSAGE.ERROR.${err?.message}`) || err?.message || 'เกิดข้อผิดพลาด')
        })
        .finally(() => {
          setLoading(false)
        })

      return
    }

    // Handle UPDATE action (old code for backward compatibility)
    dataChange.advanceItems = []

    dataChange.amountTotal = 0
    if (dataChange.amountCash !== undefined) {
      dataChange.advanceItems.push({
        paymentChannelId: 1,
        bankId: null,
        bankNumber: null,
        cardTypeId: null,
        // amount: Number(dataChange.amountCash) + Number(dataChange.usedCash),
        amount: Number(dataChange.amountCash),
      })
      dataChange.amountTotal += Number(dataChange.amountCash) + Number(dataChange.usedCash)
    }
    if (dataChange.amountWallet !== undefined) {
      dataChange.advanceItems.push({
        paymentChannelId: 10,
        bankId: null,
        bankNumber: null,
        cardTypeId: null,
        amount: Number(dataChange.amountWallet),
        // amount: Number(dataChange.amountWallet) + Number(dataChange.usedWallet),
      })
      dataChange.amountTotal += Number(dataChange.amountWallet) + Number(dataChange.usedWallet)
    }
    if (dataChange.amountTransfer !== undefined) {
      dataChange.advanceItems.push({
        paymentChannelId: 2,
        bankId: bankTransfer.bankId,
        bankAccountNumber: bankTransfer.bankAccountNumber,
        cardTypeId: null,
        // amount: Number(dataChange.amountTransfer) + Number(dataChange.usedTransfer),
        amount: Number(dataChange.amountTransfer),
      })
      dataChange.amountTotal += Number(dataChange.amountTransfer) + Number(dataChange.usedTransfer)

    }

    if (dataChange.amountCredit !== undefined) {
      dataChange.advanceItems.push({
        paymentChannelId: 3,
        bankId: bankCredit.bankId,
        cardTypeId: bankCredit?.cardTypeId,
        bankAccountNumber: bankCredit.bankAccountNumber,
        amount: Number(dataChange.amountCredit),
        // amount: Number(dataChange.amountCredit) + Number(dataChange.usedCredit),
      })
      dataChange.amountTotal += Number(dataChange.amountTransfer) + Number(dataChange.usedTransfer)

    }

    if (dataChange.amountDebit !== undefined) {
      dataChange.advanceItems.push({
        paymentChannelId: 4,
        bankId: bankDebit.bankId,
        cardTypeId: bankDebit?.cardTypeId,
        bankAccountNumber: bankDebit.bankAccountNumber,
        amount: Number(dataChange.amountDebit),
        // amount: Number(dataChange.amountDebit) + Number(dataChange.usedDebit),
      })
      dataChange.amountTotal += Number(dataChange.amountDebit) + Number(dataChange.usedDebit)
    }

    if (dataChange.amountVoucher !== undefined) {
      dataChange.advanceItems.push({
        paymentChannelId: 7,
        bankId: null,
        bankNumber: null,
        cardTypeId: null,
        amount: Number(dataChange.amountVoucher),
        // amount: Number(dataChange.amountVoucher) + Number(dataChange.usedVoucher),
      })
      dataChange.amountTotal += Number(dataChange.amountVoucher) + Number(dataChange.usedVoucher)
    }

    const payload: any = {
      amountTotal: dataChange.amountTotal,
      userId: dataChange.userId,
      remark: dataEdit.data.remark,
      advanceItems: dataChange.advanceItems
    }

    setLoading(true)
    AdvanceApi.update(dataChange.transectionAdvanceId, payload)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          if (props?.handleSuccess) props?.handleSuccess()
          dispatch(resetModal())
          const actionType = dataEdit.action
          setDataEdit({ data: null, action: "TRANSFER", newPatientId: 0, amount: 0, newPatient: null })
          setFillter({ patientId: 0, page: 1, pageLimit: 10, sortBy: 'createdAt', sortType: "DESC" })
          setDataChange(null)
          const messageKey = actionType === "TRANSFER" ? 'ADVANCE.MESSAGE.SUCCESS.TRANSFER' : 'ADVANCE.MESSAGE.SUCCESS.UPDATE'
          const fallbackMessage = actionType === "TRANSFER" ? 'โอนเงินล่วงหน้าสำเร็จ' : 'อัปเดตสำเร็จ'
          const translatedMessage = t(messageKey)
          notiSuccess(translatedMessage === messageKey ? fallbackMessage : translatedMessage)
          props?.setIsShow(false)

        } else {
          const err = res.response?.data
          notiError(t(`ADVANCE.MESSAGE.${err.message}`))


        }
      })
      .catch((e) => {
        const err = e.response.data
        notiError(t(`ADVANCE.MESSAGE.${err.message}`))


      })
      .finally(() => {
        setLoading(false)
      })
  }
  return props.isShow ?
    dataEdit?.data ?
      (
        <>
          <UseStyled.ModalStyle size={'xl'} show={props.isShow} centered >
            <Modal.Body className="modal-body py-0 overflow-hidden" >
              <Loading show={loading} type="fullLoading" />
              <Box>
                <Typography className="py-3 text-center" sx={{ fontSize: 20, color: colors.themeMainColor, fontWeight: 600 }}>
                  {dataEdit.action === "TRANSFER" ? t('โอนเงินล่วงหน้า') : t('ปรับเปลี่ยนยอดเงินล่วงหน้า')}
                </Typography>
              </Box>
              <Grid container spacing={2} className="my-0 h-100 pb-4">
                <Grid lg={6} item className={`w-100 h-100 ${activePage === 0 ? 'd-block' : 'd-none'} d-xl-block`}>
                  <Box className="pr-xl-3 h-100 d-flex flex-column">
                    <Typography className="pb-4 text-center" sx={{ fontSize: 20, color: colors.themeMainColor, fontWeight: 600 }}>
                      {dataEdit.action === "TRANSFER" ? t('รายละเอียดการโอนเงินล่วงหน้า') : t('รายละเอียดการจัดการเงินล่วงหน้า')}
                    </Typography>
                    <Info patient={props.patient} advance={dataEdit.data.amountTotal} balance={dataEdit.data.advanceBalance} />
                    <Box className="custom-scroll" sx={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 'calc(90vh - 300px)', flex: 1, minHeight: 'calc(80vh - 400px)', }}>
                      {dataEdit.action === "TRANSFER" ? (
                        <>
                          <Box className="px-md-2 px-xl-3 mb-3">
                            <Typography sx={{ fontSize: 16, fontWeight: 600, color: colors.themeMainColor, mb: 2 }}>
                              {t('ผู้ป่วยที่รับเงินล่วงหน้า')}
                            </Typography>
                            {/* เลือกวิธีจัดการเงินล่วงหน้า */}
                            <Box className="px-md-2 px-xl-3 mb-3">
                              <FormControl component="fieldset" className="d-flex flex-column gap-2">
                                <RadioGroup
                                  value={transferOption}
                                  onChange={(e) => setTransferOption(e.target.value as 'TO_PATIENT' | 'CUT_OUT')}
                                >
                                  <FormControlLabel
                                    value="TO_PATIENT"
                                    control={<InputRadio />}
                                    label={
                                      <Box>
                                        <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.themeMainColor }}>
                                          {t('โอนเงินให้ผู้ป่วยปลายทาง')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('เงินล่วงหน้าจะถูกย้ายไปให้ผู้ป่วยที่เลือก')}
                                        </Typography>
                                      </Box>
                                    }
                                  />
                                  {/* <FormControlLabel
                                    value="CUT_OUT"
                                    control={<InputRadio />}
                                    label={
                                      <Box>
                                        <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.themeMainColor }}>
                                          {t('ตัดเงินออกจากผู้ป่วยต้นทาง')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('เงินล่วงหน้าจะไม่ถูกโอนไปให้ผู้ป่วยอื่น')}
                                        </Typography>
                                      </Box>
                                    }
                                  /> */}
                                </RadioGroup>
                              </FormControl>
                            </Box>

                            <SearchPatients
                              status="ACTIVE"
                              bodyHeight={43}
                              optionBelowSideBar
                              callbackPatient={(patient: any) => {
                                setDataEdit((old: any) => ({
                                  ...old,
                                  newPatientId: patient?.patientId || 0,
                                  newPatient: patient
                                }))
                              }}
                              callbackPatientId={(id: any) => {
                                setDataEdit((old: any) => ({
                                  ...old,
                                  newPatientId: id || 0
                                }))
                              }}
                              patientId={dataEdit.newPatientId}
                              onClear={() => setDataEdit((old: any) => ({ ...old, newPatientId: 0, newPatient: null }))}
                            />
                          </Box>


                          <Box className="px-md-2 px-xl-3 mb-3">
                            <InputTextField
                              label={t('จำนวนเงินที่ต้องการโอน')}
                              type="number"
                              value={transferAmount}
                              inputTextAlign="right"
                              hideControl
                              inputProps={{ min: 0, step: 0.01, inputMode: 'decimal' }}
                              onchange={(e: any) => {
                                const amount = Number(String(e.target.value).replace(/[^0-9.]/g, '')) || 0
                                setTransferAmount(amount)
                              }}
                              helperText={transferAmount > dataEdit.data.advanceBalance ? t('จำนวนเงินที่โอนเกินยอดคงเหลือ') : ''}
                            />
                            <Typography sx={{ fontSize: 14, color: colors.themeMainColor, mt: 1 }}>
                              {t('ยอดคงเหลือ')}: {numberFormat(dataEdit.data.advanceBalance)} {t('CURRENCY_CHANGE.TH')}
                            </Typography>
                          </Box>
                        </>
                      ) : dataEdit.action === "ADJUST" ? (
                        <>
                          <Box className="px-md-2 px-xl-3 mb-3">
                            <Typography sx={{ fontSize: 16, fontWeight: 600, color: colors.themeMainColor, mb: 2 }}>
                              {t('ปรับเปลี่ยนยอดคงเหลือ')}
                            </Typography>
                            <Box className="px-md-2 px-xl-3 mb-3">
                              <InputTextField
                                label={t('ยอดคงเหลือที่ต้องการ')}
                                type="number"
                                value={adjustTargetBalance}
                                inputTextAlign="right"
                                hideControl
                                inputProps={{ min: 0, step: 0.01, inputMode: 'decimal' }}
                                onchange={(e: any) => {
                                  const amount = Number(String(e.target.value).replace(/[^0-9.]/g, '')) || 0
                                  setAdjustTargetBalance(amount)
                                }}
                                helperText={t('ระบบจะปรับรายการในใบเสร็จให้ยอดคงเหลือเท่ากับยอดที่ระบุ')}
                              />
                              <Typography sx={{ fontSize: 14, color: colors.themeMainColor, mt: 1 }}>
                                {t('ยอดคงเหลือปัจจุบัน')}: {numberFormat(dataEdit.data.advanceBalance)} {t('CURRENCY_CHANGE.TH')}
                              </Typography>
                              {adjustTargetBalance !== dataEdit.data.advanceBalance && (
                                <>
                                  <Typography sx={{ fontSize: 14, color: colors.themeMainColor, mt: 1 }}>
                                    {t('ยอดคงเหลือที่ต้องการ')}: {numberFormat(adjustTargetBalance)} {t('CURRENCY_CHANGE.TH')}
                                  </Typography>
                                  <Typography sx={{
                                    fontSize: 14,
                                    color: adjustTargetBalance > dataEdit.data.advanceBalance ? colors.statusSuccess : colors.statusDangerColor,
                                    mt: 1,
                                    fontWeight: 600
                                  }}>
                                    {adjustTargetBalance > dataEdit.data.advanceBalance
                                      ? `+${numberFormat(adjustTargetBalance - dataEdit.data.advanceBalance)} ${t('CURRENCY_CHANGE.TH')} (เพิ่มยอด)`
                                      : `${numberFormat(adjustTargetBalance - dataEdit.data.advanceBalance)} ${t('CURRENCY_CHANGE.TH')} (ลดยอด)`
                                    }
                                  </Typography>
                                </>
                              )}
                            </Box>
                            <Box className="px-md-2 px-xl-3 mb-3">
                              <InputTextarea
                                label={t('หมายเหตุ')}
                                value={adjustRemark}
                                onchange={(e: any) => setAdjustRemark(e.target.value)}
                                rows={3}
                              />
                            </Box>
                          </Box>
                        </>
                      ) : (
                        <PaymentChannels
                          banks={props.banks}
                          advance={true}
                          selectChannels={dataEdit.selectChannels}
                          data={dataChange}
                          onChange={(value: any) => setDataChange((old: any) => ({ ...old, ...value }))} />
                      )}
                    </Box>
                    <UseStyled.FooterStepButton className="d-flex d-xl-none justify-content-md-end mt-2 mr-md-2">
                      <ButtonCustom textButton={t('BUTTON.CANCEL')} variant="outlined" onClick={() => props.setIsShow(false)} />
                      <ButtonCustom textButton={t('BUTTON.NEXT')} disabled={disabledNext || loading}
                        onClick={() => {
                          setActivePage(1)
                          setDisabledNext(true)
                        }}
                      />
                    </UseStyled.FooterStepButton>
                  </Box>
                </Grid>
                <Grid lg={6} item className={`w-100 h-100 ${activePage === 1 ? 'd-block' : 'd-none'} d-xl-block`} sx={{ borderLeft: { lg: `1px solid ${colors.lightGray}` } }}>
                  <Box className="h-100 d-flex flex-column">
                    <Typography className="pb-4 text-center" sx={{ fontSize: 20, color: colors.themeMainColor, fontWeight: 600 }}>
                      {dataEdit.action === "TRANSFER" ? t('สรุปยอดการโอนเงินล่วงหน้า') : t('สรุปยอดการชำระเงินล่วงหน้า')}
                    </Typography>
                    <Box className="custom-scroll mb-3" sx={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 'calc(80vh - 300px)', flex: 1 }}>
                      <UseStyled.SummaryNetPrice className="d-flex align-items-center mx-md-3 mx-xl-4 mb-3">
                        <Box className="d-flex align-items-center justify-content-center flex-column h-100">
                          <Typography className="text-center" sx={{ fontSize: 20, color: colors.themeMainColor, fontWeight: 600 }}>
                            {numberFormat(dataEdit.data.amountTotal)} {t('CURRENCY_CHANGE.TH')}
                          </Typography>
                          <Typography className="text-center" sx={{ fontSize: 14, color: colors.themeMainColor }}>
                            {t('ยอดจ่ายเงินล่วงหน้า')}
                          </Typography>
                        </Box>
                        <Box className="d-flex align-items-center justify-content-center flex-column h-100" sx={{ borderLeft: `1px solid ${colors.lightGray}` }}>
                          <Typography className="text-center" sx={{ fontSize: 20, color: colors.themeMainColor, fontWeight: 600 }}>
                            {numberFormat(dataEdit.data.advanceBalance)} {t('CURRENCY_CHANGE.TH')}
                          </Typography>
                          <Typography className="text-center" sx={{ fontSize: 14, color: colors.themeMainColor }}>
                            {t('คงเหลือ')}
                          </Typography>
                        </Box>
                      </UseStyled.SummaryNetPrice>

                      {dataEdit.action === "TRANSFER" ? (
                        <>
                          {/* สรุปการโอนเงินล่วงหน้า */}
                          <Box className="px-md-2 px-xl-3 mb-3">
                            <Typography sx={{ fontSize: 18, fontWeight: 600, color: colors.themeMainColor, mb: 3 }}>
                              {t('สรุปการโอนเงินล่วงหน้า')}
                            </Typography>

                            {/* ข้อมูลผู้ป่วยต้นทาง */}
                            <Box className="mb-3">
                              <Typography sx={{ fontSize: 16, fontWeight: 600, color: colors.themeMainColor, mb: 2 }}>
                                {t('ผู้ป่วยต้นทาง (โอนออก)')}
                              </Typography>
                              <Box sx={{
                                border: `1px solid ${colors.lightGray}`,
                                borderRadius: 1,
                                p: 2,
                                backgroundColor: colors.white
                              }}>
                                <Typography sx={{ fontSize: 14, fontWeight: 500, color: colors.themeMainColor }}>
                                  {props.patient.branchCnNumber ? `${props.patient.branchCnNumber} | ` : ''}
                                  {props.patient.firstname} {props.patient.lastname}
                                </Typography>
                                <Box className="d-flex justify-content-between mt-2">
                                  <Typography sx={{ fontSize: 14, color: colors.textPrimary }}>
                                    {t('ยอดคงเหลือก่อนโอน')}
                                  </Typography>
                                  <Typography sx={{ fontSize: 14, fontWeight: 500, color: colors.themeMainColor }}>
                                    {numberFormat(dataEdit.data.advanceBalance)} {t('CURRENCY_CHANGE.TH')}
                                  </Typography>
                                </Box>
                                <Box className="d-flex justify-content-between mt-1">
                                  <Typography sx={{ fontSize: 14, color: colors.textPrimary }}>
                                    {t('จำนวนเงินที่โอน')}
                                  </Typography>
                                  <Typography sx={{ fontSize: 14, fontWeight: 500, color: colors.themeMainColor }}>
                                    {numberFormat(transferAmount || 0)} {t('CURRENCY_CHANGE.TH')}
                                  </Typography>
                                </Box>
                                <Box className="d-flex justify-content-between mt-1" sx={{ borderTop: `1px solid ${colors.lightGray}`, pt: 1 }}>
                                  <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.textPrimary }}>
                                    {t('ยอดคงเหลือหลังโอน')}
                                  </Typography>
                                  <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.themeMainColor }}>
                                    {numberFormat((dataEdit.data.advanceBalance || 0) - (transferAmount || 0))} {t('CURRENCY_CHANGE.TH')}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>

                            {/* ข้อมูลผู้ป่วยปลายทาง */}
                            {dataEdit.newPatient && transferOption === 'TO_PATIENT' && (
                              <Box className="mb-3">
                                <Typography sx={{ fontSize: 16, fontWeight: 600, color: colors.themeMainColor, mb: 2 }}>
                                  {t('ผู้ป่วยปลายทาง (รับเข้า)')}
                                </Typography>
                                <Box sx={{
                                  border: `1px solid ${colors.lightGray}`,
                                  borderRadius: 1,
                                  p: 2,
                                  backgroundColor: colors.white
                                }}>
                                  <Typography sx={{ fontSize: 14, fontWeight: 500, color: colors.themeMainColor }}>
                                    {dataEdit.newPatient.branchCnNumber ? `${dataEdit.newPatient.branchCnNumber} | ` : ''}
                                    {dataEdit.newPatient.firstname} {dataEdit.newPatient.lastname}
                                  </Typography>
                                  <Box className="d-flex justify-content-between mt-2">
                                    <Typography sx={{ fontSize: 14, color: colors.textPrimary }}>
                                      {t('จำนวนเงินที่รับ')}
                                    </Typography>
                                    <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.themeMainColor }}>
                                      {numberFormat(transferAmount || 0)} {t('CURRENCY_CHANGE.TH')}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            )}

                            {/* สรุปยอดรวม */}
                            <Box className="mb-3" sx={{
                              border: `2px solid ${colors.themeSecondColor}`,
                              borderRadius: 1,
                              p: 2,
                              backgroundColor: colors.white
                            }}>
                              <Box className="d-flex justify-content-between align-items-center">
                                <Typography sx={{ fontSize: 16, fontWeight: 600, color: colors.themeMainColor }}>
                                  {t('ยอดรวมการโอน')}
                                </Typography>
                                <Typography sx={{ fontSize: 20, fontWeight: 600, color: colors.themeSecondColor }}>
                                  {numberFormat(transferAmount || 0)} {t('CURRENCY_CHANGE.TH')}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </>
                      ) : dataEdit.action === "ADJUST" ? (
                        <>
                          {/* ส่วนสรุปสำหรับ ADJUST action */}
                          <Box className="px-md-2 px-xl-3 mb-3">
                            <Typography sx={{ fontSize: 18, fontWeight: 600, color: colors.themeMainColor, mb: 3 }}>
                              {t('สรุปการปรับเปลี่ยนยอดคงเหลือ')}
                            </Typography>

                            {/* ข้อมูลใบเสร็จ */}
                            <Box className="mb-3">
                              <Typography sx={{ fontSize: 16, fontWeight: 600, color: colors.themeMainColor, mb: 2 }}>
                                {t('ใบเสร็จ')}
                              </Typography>
                              <Box sx={{
                                border: `1px solid ${colors.lightGray}`,
                                borderRadius: 1,
                                p: 2,
                                backgroundColor: colors.white
                              }}>
                                <Typography sx={{ fontSize: 14, fontWeight: 500, color: colors.themeMainColor }}>
                                  {dataEdit.data.prefix}-{dataEdit.data.advanceNumber}
                                </Typography>
                                <Box className="d-flex justify-content-between mt-2">
                                  <Typography sx={{ fontSize: 14, color: colors.textPrimary }}>
                                    {t('ยอดคงเหลือปัจจุบัน')}
                                  </Typography>
                                  <Typography sx={{ fontSize: 14, fontWeight: 500, color: colors.themeMainColor }}>
                                    {numberFormat(dataEdit.data.advanceBalance)} {t('CURRENCY_CHANGE.TH')}
                                  </Typography>
                                </Box>
                                <Box className="d-flex justify-content-between mt-1">
                                  <Typography sx={{ fontSize: 14, color: colors.textPrimary }}>
                                    {t('ยอดคงเหลือที่ต้องการ')}
                                  </Typography>
                                  <Typography sx={{ fontSize: 14, fontWeight: 500, color: colors.themeMainColor }}>
                                    {numberFormat(adjustTargetBalance)} {t('CURRENCY_CHANGE.TH')}
                                  </Typography>
                                </Box>
                                {adjustTargetBalance !== dataEdit.data.advanceBalance && (
                                  <Box className="d-flex justify-content-between mt-1" sx={{ borderTop: `1px solid ${colors.lightGray}`, pt: 1 }}>
                                    <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.textPrimary }}>
                                      {t('การเปลี่ยนแปลง')}
                                    </Typography>
                                    <Typography sx={{
                                      fontSize: 14,
                                      fontWeight: 600,
                                      color: adjustTargetBalance > dataEdit.data.advanceBalance ? colors.statusSuccess : colors.statusDangerColor
                                    }}>
                                      {adjustTargetBalance > dataEdit.data.advanceBalance ? '+' : ''}
                                      {numberFormat(adjustTargetBalance - dataEdit.data.advanceBalance)} {t('CURRENCY_CHANGE.TH')}
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            </Box>

                            {/* สรุปยอดรวม */}
                            <Box className="mb-3" sx={{
                              border: `2px solid ${colors.themeSecondColor}`,
                              borderRadius: 1,
                              p: 2,
                              backgroundColor: colors.white
                            }}>
                              <Box className="d-flex justify-content-between align-items-center">
                                <Typography sx={{ fontSize: 16, fontWeight: 600, color: colors.themeMainColor }}>
                                  {t('ยอดคงเหลือหลังปรับ')}
                                </Typography>
                                <Typography sx={{ fontSize: 20, fontWeight: 600, color: colors.themeSecondColor }}>
                                  {numberFormat(adjustTargetBalance)} {t('CURRENCY_CHANGE.TH')}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </>
                      ) : (
                        <>
                          {/* ส่วนสรุปสำหรับ UPDATE action (old code) */}
                          {(() => {
                            // Hidden: เรื่องปรับเปลี่ยนยอด
                            return null;

                            // คำนวณยอดเดิมจาก transectionAdvanceItems
                            const getOriginalAmount = (paymentChannelId: number) => {
                              if (!dataEdit.data?.transectionAdvanceItems) return 0
                              const item = dataEdit.data.transectionAdvanceItems.find((i: any) => i.paymentChannelId === paymentChannelId)
                              return item ? (item.amount || 0) : 0
                            }

                            const getOriginalUsed = (paymentChannelId: number) => {
                              if (!dataEdit.data?.transectionAdvanceItems) return 0
                              const item = dataEdit.data.transectionAdvanceItems.find((i: any) => i.paymentChannelId === paymentChannelId)
                              return item ? (item.used || 0) : 0
                            }

                            // คำนวณยอดเดิมรวมจาก transectionAdvanceItems
                            const originalAmountTotal = dataEdit.data?.transectionAdvanceItems?.reduce((sum: number, item: any) => {
                              return sum + (item.amount || 0)
                            }, 0) || dataEdit.data?.amountTotal || 0

                            // คำนวณยอดใหม่รวม
                            const newAmountTotal = dataChange.amountTotal || 0

                            return (
                              <Box className="px-md-2 px-xl-3 mb-3">
                                <Typography sx={{ fontSize: 18, fontWeight: 600, color: colors.themeMainColor, mb: 3 }}>
                                  {t('สรุปการปรับเปลี่ยนยอดเงินล่วงหน้า')}
                                </Typography>

                                {/* สรุปยอดรวม */}
                                <Box className="mb-3" sx={{
                                  border: `1px solid ${colors.lightGray}`,
                                  borderRadius: 1,
                                  p: 2,
                                  backgroundColor: colors.white
                                }}>
                                  <Typography sx={{ fontSize: 16, fontWeight: 600, color: colors.themeMainColor, mb: 2 }}>
                                    {t('ยอดรวมเงินล่วงหน้า')}
                                  </Typography>

                                  <Box className="d-flex justify-content-between mb-2">
                                    <Typography sx={{ fontSize: 14, color: colors.textPrimary }}>
                                      {t('ยอดเดิม')}
                                    </Typography>
                                    <Typography sx={{ fontSize: 14, fontWeight: 500, color: colors.textPrimary }}>
                                      {numberFormat(originalAmountTotal)} {t('CURRENCY_CHANGE.TH')}
                                    </Typography>
                                  </Box>

                                  <Box className="d-flex justify-content-between mb-2">
                                    <Typography sx={{ fontSize: 14, color: colors.textPrimary }}>
                                      {t('ยอดใหม่')}
                                    </Typography>
                                    <Typography sx={{ fontSize: 14, fontWeight: 500, color: colors.themeMainColor }}>
                                      {numberFormat(newAmountTotal)} {t('CURRENCY_CHANGE.TH')}
                                    </Typography>
                                  </Box>

                                  <Box className="d-flex justify-content-between mt-2" sx={{ borderTop: `1px solid ${colors.lightGray}`, pt: 2 }}>
                                    <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.textPrimary }}>
                                      {t('ผลต่าง')}
                                    </Typography>
                                    <Typography sx={{
                                      fontSize: 16,
                                      fontWeight: 600,
                                      color: newAmountTotal >= originalAmountTotal ? colors.statusSuccess : colors.statusDangerColor
                                    }}>
                                      {newAmountTotal >= originalAmountTotal ? '+' : ''}
                                      {numberFormat(newAmountTotal - originalAmountTotal)} {t('CURRENCY_CHANGE.TH')}
                                    </Typography>
                                  </Box>
                                </Box>

                                {/* รายละเอียดแต่ละช่องทางการชำระ */}
                                <Typography sx={{ fontSize: 16, fontWeight: 600, color: colors.themeMainColor, mb: 2 }}>
                                  {t('รายละเอียดช่องทางการชำระ')}
                                </Typography>

                                {/* Cash */}
                                {((dataChange.amountCash !== undefined && dataChange.amountCash !== null) ||
                                  (dataEdit.data?.transectionAdvanceItems?.some((item: any) => item.paymentChannelId === 1))) && (
                                    <Box className="mb-2" sx={{
                                      border: `1px solid ${colors.lightGray}`,
                                      borderRadius: 1,
                                      p: 2,
                                      backgroundColor: colors.white
                                    }}>
                                      <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.themeMainColor, mb: 1 }}>
                                        {t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.CASH')}
                                      </Typography>
                                      <Box className="d-flex justify-content-between">
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('ยอดเดิม')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {numberFormat(getOriginalAmount(1))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                      <Box className="d-flex justify-content-between">
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('ใช้ไปแล้ว')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {numberFormat(dataChange.usedCash || getOriginalUsed(1))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                      <Box className="d-flex justify-content-between mt-1">
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: colors.themeMainColor }}>
                                          {t('ยอดใหม่')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: colors.themeMainColor }}>
                                          {numberFormat((dataChange.amountCash || 0))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  )}

                                {/* Transfer */}
                                {((dataChange.amountTransfer !== undefined && dataChange.amountTransfer !== null) ||
                                  (dataEdit.data?.transectionAdvanceItems?.some((item: any) => item.paymentChannelId === 2))) && (
                                    <Box className="mb-2" sx={{
                                      border: `1px solid ${colors.lightGray}`,
                                      borderRadius: 1,
                                      p: 2,
                                      backgroundColor: colors.white
                                    }}>
                                      <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.themeMainColor, mb: 1 }}>
                                        {t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.TRANSFER')}
                                        {bankTransfer?.bankName && ` - ${bankTransfer.bankName}`}
                                      </Typography>
                                      <Box className="d-flex justify-content-between">
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('ยอดเดิม')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {numberFormat(getOriginalAmount(2))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                      <Box className="d-flex justify-content-between">
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('ใช้ไปแล้ว')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {numberFormat(dataChange.usedTransfer || getOriginalUsed(2))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                      <Box className="d-flex justify-content-between mt-1">
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: colors.themeMainColor }}>
                                          {t('ยอดใหม่')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: colors.themeMainColor }}>
                                          {numberFormat((dataChange.amountTransfer || 0))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  )}

                                {/* Credit */}
                                {((dataChange.amountCredit !== undefined && dataChange.amountCredit !== null) ||
                                  (dataEdit.data?.transectionAdvanceItems?.some((item: any) => item.paymentChannelId === 3))) && (
                                    <Box className="mb-2" sx={{
                                      border: `1px solid ${colors.lightGray}`,
                                      borderRadius: 1,
                                      p: 2,
                                      backgroundColor: colors.white
                                    }}>
                                      <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.themeMainColor, mb: 1 }}>
                                        {t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.CREDIT')}
                                        {bankCredit?.bankName && ` - ${bankCredit.bankName}`}
                                      </Typography>
                                      <Box className="d-flex justify-content-between">
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('ยอดเดิม')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {numberFormat(getOriginalAmount(3))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                      <Box className="d-flex justify-content-between">
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('ใช้ไปแล้ว')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {numberFormat(dataChange.usedCredit || getOriginalUsed(3))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                      <Box className="d-flex justify-content-between mt-1">
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: colors.themeMainColor }}>
                                          {t('ยอดใหม่')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: colors.themeMainColor }}>
                                          {numberFormat((dataChange.amountCredit || 0))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  )}

                                {/* Debit */}
                                {((dataChange.amountDebit !== undefined && dataChange.amountDebit !== null) ||
                                  (dataEdit.data?.transectionAdvanceItems?.some((item: any) => item.paymentChannelId === 4))) && (
                                    <Box className="mb-2" sx={{
                                      border: `1px solid ${colors.lightGray}`,
                                      borderRadius: 1,
                                      p: 2,
                                      backgroundColor: colors.white
                                    }}>
                                      <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.themeMainColor, mb: 1 }}>
                                        {t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.DEBIT')}
                                        {bankDebit?.bankName && ` - ${bankDebit.bankName}`}
                                      </Typography>
                                      <Box className="d-flex justify-content-between">
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('ยอดเดิม')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {numberFormat(getOriginalAmount(4))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                      <Box className="d-flex justify-content-between">
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('ใช้ไปแล้ว')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {numberFormat(dataChange.usedDebit || getOriginalUsed(4))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                      <Box className="d-flex justify-content-between mt-1">
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: colors.themeMainColor }}>
                                          {t('ยอดใหม่')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: colors.themeMainColor }}>
                                          {numberFormat((dataChange.amountDebit || 0))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  )}

                                {/* Wallet */}
                                {((dataChange.amountWallet !== undefined && dataChange.amountWallet !== null) ||
                                  (dataEdit.data?.transectionAdvanceItems?.some((item: any) => item.paymentChannelId === 10))) && (
                                    <Box className="mb-2" sx={{
                                      border: `1px solid ${colors.lightGray}`,
                                      borderRadius: 1,
                                      p: 2,
                                      backgroundColor: colors.white
                                    }}>
                                      <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.themeMainColor, mb: 1 }}>
                                        {t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.WALLET')}
                                      </Typography>
                                      <Box className="d-flex justify-content-between">
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('ยอดเดิม')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {numberFormat(getOriginalAmount(10))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                      <Box className="d-flex justify-content-between">
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('ใช้ไปแล้ว')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {numberFormat(dataChange.usedWallet || getOriginalUsed(10))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                      <Box className="d-flex justify-content-between mt-1">
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: colors.themeMainColor }}>
                                          {t('ยอดใหม่')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: colors.themeMainColor }}>
                                          {numberFormat((dataChange.amountWallet || 0))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  )}

                                {/* Voucher */}
                                {((dataChange.amountVoucher !== undefined && dataChange.amountVoucher !== null) ||
                                  (dataEdit.data?.transectionAdvanceItems?.some((item: any) => item.paymentChannelId === 7))) && (
                                    <Box className="mb-2" sx={{
                                      border: `1px solid ${colors.lightGray}`,
                                      borderRadius: 1,
                                      p: 2,
                                      backgroundColor: colors.white
                                    }}>
                                      <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.themeMainColor, mb: 1 }}>
                                        {t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.VOUCHER')}
                                      </Typography>
                                      <Box className="d-flex justify-content-between">
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('ยอดเดิม')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {numberFormat(getOriginalAmount(7))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                      <Box className="d-flex justify-content-between">
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {t('ใช้ไปแล้ว')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, color: colors.textPrimary }}>
                                          {numberFormat(dataChange.usedVoucher || getOriginalUsed(7))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                      <Box className="d-flex justify-content-between mt-1">
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: colors.themeMainColor }}>
                                          {t('ยอดใหม่')}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: colors.themeMainColor }}>
                                          {numberFormat((dataChange.amountVoucher || 0))} {t('CURRENCY_CHANGE.TH')}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  )}

                                {/* สรุปยอดคงเหลือหลังปรับเปลี่ยน */}
                                <Box className="mt-3" sx={{
                                  border: `2px solid ${colors.themeSecondColor}`,
                                  borderRadius: 1,
                                  p: 2,
                                  backgroundColor: colors.white
                                }}>
                                  <Box className="d-flex justify-content-between align-items-center mb-2">
                                    <Typography sx={{ fontSize: 14, color: colors.textPrimary }}>
                                      {t('ยอดคงเหลือเดิม')}
                                    </Typography>
                                    <Typography sx={{ fontSize: 14, fontWeight: 500, color: colors.textPrimary }}>
                                      {numberFormat(dataEdit.data.advanceBalance || 0)} {t('CURRENCY_CHANGE.TH')}
                                    </Typography>
                                  </Box>

                                  <Box className="d-flex justify-content-between align-items-center mb-2">
                                    <Typography sx={{ fontSize: 14, color: colors.textPrimary }}>
                                      {t('ผลต่างยอดรวม')}
                                    </Typography>
                                    <Typography sx={{
                                      fontSize: 14,
                                      fontWeight: 500,
                                      color: newAmountTotal >= originalAmountTotal ? colors.statusSuccess : colors.statusDangerColor
                                    }}>
                                      {newAmountTotal >= originalAmountTotal ? '+' : ''}
                                      {numberFormat(newAmountTotal - originalAmountTotal)} {t('CURRENCY_CHANGE.TH')}
                                    </Typography>
                                  </Box>

                                  <Box className="d-flex justify-content-between align-items-center" sx={{ borderTop: `1px solid ${colors.lightGray}`, pt: 2 }}>
                                    <Typography sx={{ fontSize: 16, fontWeight: 600, color: colors.themeMainColor }}>
                                      {t('ยอดคงเหลือหลังปรับเปลี่ยน')}
                                    </Typography>
                                    <Typography sx={{ fontSize: 18, fontWeight: 600, color: colors.themeSecondColor }}>
                                      {numberFormat(
                                        (dataEdit.data.advanceBalance || 0) +
                                        (newAmountTotal - originalAmountTotal)
                                      )} {t('CURRENCY_CHANGE.TH')}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            )
                          })()}
                        </>
                      )}

                      <Box className="px-md-2 px-xl-3 mb-md-2 pt-md-2">
                        <InputTextarea
                          key={'important-symptoms'}
                          onchange={(e: any) => {
                            setDataEdit((value: any) => ({ ...value, data: { ...value.data, remark: e.target.value } }))
                          }}
                          value={dataEdit.data.remark}
                          label={t('PAYMENT.FORM_PAYMENT.REMARK')}
                        />
                      </Box>
                    </Box>
                    <UseStyled.FooterPaymentButton className=" mt-auto" display='flex' alignItems='center' justifyContent='flex-end' gap='16px'>
                      <ButtonCustom textButton={t('PAYMENT.FORM_PAYMENT.BUTTON_BACK_TO_DETAIL')} variant="outlined" onClick={() => {
                        setActivePage(0)
                        setDisabledNext(false)
                      }} className="d-xl-none" />
                      <Box className="d-none d-xl-block" maxWidth='120px' width='100%'>
                        <MainButton
                          title={t('BUTTON.CANCEL')}
                          variant="outlined"
                          type='secondary'
                          onClick={() => {
                            setDataEdit({ data: null, action: "TRANSFER", newPatientId: 0, amount: 0, newPatient: null })
                            props.setIsShow(false)
                            // dispatch(resetStatePayment())
                          }}
                        />
                      </Box>

                      <Box className="d-none d-xl-block" maxWidth='120px' width='100%'>
                        <MainButton
                          title={t('BUTTON.SAVE')}
                          variant="contained"
                          type='primary'
                          disabled={loading}
                          onClick={submit}
                        />
                      </Box>
                    </UseStyled.FooterPaymentButton>
                  </Box>
                </Grid>
              </Grid>
            </Modal.Body>
          </UseStyled.ModalStyle>
        </>
      ) : (
        <ModalCustom
          size={'xl'}
          title={'จัดการรายการรับเงินล่วงหน้า'}
          // alignFooter={'end'}
          // fullscreen={'lg-down'}
          component={

            <>
              <div className="mb-4 col-12 col-md-12  col-xl-6" >
                <SearchPatients status="ACTIVE" bodyHeight={43} callbackPatientId={(id: any) => setFillter({ ...fillter, patientId: id })} patientId={fillter.patientId} onClear={() => setFillter({ ...fillter, patientId: 0 })} />
              </div>
              <TableCustom
                page={fillter.page}
                pageLimit={fillter.pageLimit}
                sortType={fillter.sortType}
                sortBy={fillter.sortBy}
                rowCount={props.advanceHistory.rowCount}
                onSort={(sortByVal: string, sortTypeVal: string) => {
                  setFillter({ ...fillter, sortType: sortTypeVal, sortBy: sortByVal })
                }}
                setPageLimit={(pageLimit) => setFillter({ ...fillter, pageLimit })}
                setPage={(page) => setFillter({ ...fillter, page })}
                headCells={headCells}
                rowsData={_.map(props.advanceHistory.history, renderData)}
              />
            </>


          }
          onReset={() => {
            setDataEdit({ data: null, action: "TRANSFER", newPatientId: 0, amount: 0, newPatient: null })
            props.setIsShow(false)
          }}
          onSubmit={() => {
            setDataEdit({ data: null, action: "TRANSFER", newPatientId: 0, amount: 0, newPatient: null })
            props.setIsShow(false)
          }}
          // disabledSubmit={loading}
          textBtnCancel={'ปิด'}
        // textBtnConfirm={t('ADVANCE.MODAL_ADD.PAYMENT')}
        />
      ) : (
      <></>
    )

}

